export default __webpack_public_path__ + "static/about-txt-cht-b9cd43d6fe32a211315d2111d1f7d461.png";